import { strapiApi } from '@blockworks/platform/api/strapi';

import { createDashboardQueries } from '@/api/dashboard/queries/dashboard-queries';

export const dashboardQueries = createDashboardQueries(strapiApi);
